// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".star-rating{width:50%}.wbzaym .card-info__wrapper{display:flex;align-items:center;padding:5px}.card-info__rate{margin-left:30px;margin-bottom:15px;width:100%}", ""]);
// Exports
module.exports = exports;
